export default __webpack_public_path__ + "static/media/ducks_responsive.a6eb8941.png";